import { createContext } from "react";

const DocumentViewerContext = createContext({
  fileName: "",
  searchBy: "",
  termsToHighlight: [],
  setSearchBy: () => {},
});

export default DocumentViewerContext;
